import { addAllToRecord, objectWithoutKeys, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { RecommendedGroupsDismissFulfilledAction } from '../../domains/recommendedGroupDismiss/actions.types';
import {
  RecommendedGroupsLoadAction,
  RecommendedGroupsLoadMoreAction,
  RecommendedGroupsLoadMoreFulfilledAction,
} from '../../domains/recommendedGroups/actions.types';

import { RecommendedGroups } from './types';

const loadMoreRecommendedGroupFulfilled = (
  state: RecommendedGroups,
  action: RecommendedGroupsLoadMoreFulfilledAction
) => {
  if (state.fulfilled) {
    return {
      ...state,
      fulfilled: addAllToRecord(state.fulfilled, action.payload.entities.recommendedGroups),
    };
  }

  return setFulfilled(action.payload.entities.recommendedGroups);
};

const dismissRecommendedGroupFulfilled = (
  state: RecommendedGroups,
  action: RecommendedGroupsDismissFulfilledAction
) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: objectWithoutKeys(state.fulfilled, [action.payload.groupId]),
  };
};

export type RecommendedGroupsAction =
  | RecommendedGroupsLoadAction
  | RecommendedGroupsLoadMoreAction
  | RecommendedGroupsDismissFulfilledAction;

const initialState: RecommendedGroups = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<RecommendedGroups, RecommendedGroupsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'RECOMMENDED_GROUPS.LOAD_PENDING':
      return setPending();
    case 'RECOMMENDED_GROUPS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'RECOMMENDED_GROUPS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.recommendedGroups);
    case 'RECOMMENDED_GROUPS.LOAD_MORE_FULFILLED':
      return loadMoreRecommendedGroupFulfilled(state, action);
    case 'RECOMMENDED_GROUPS.DISMISS_FULFILLED':
      return dismissRecommendedGroupFulfilled(state, action);
    default:
      return state;
  }
};

export default reducer;
